export default {
  me: null, //내 정보,
  accessToken: "",
  adminAccessToken: "",
  kakaoAccount: null
};
